const benefits = [
  {
    title: '外部からの攻撃をブロック',
    desc: '24時間365日、ネットワークの入口を監視し不審な通信を自動的に遮断します。',
  },
  {
    title: '危険なサイトへのアクセス防止',
    desc: '従業員が誤って危険なサイトに接続してしまっても、自動的にブロックします。',
  },
  {
    title: '社内ネットワークの安全性向上',
    desc: '社内のすべてのパソコン・スマートフォンをまとめて保護できます。',
  },
  {
    title: 'IT管理の負担軽減',
    desc: '一元管理で設定・運用がシンプルに。IT担当がいない企業でも安心して使えます。',
  },
  {
    title: 'テレワーク・外出先でも安全',
    desc: 'VPN機能により在宅勤務や外出中でも社内と同じセキュリティ環境で業務できます。',
  },
  {
    title: 'コンプライアンス対応',
    desc: '取引先や大手企業からのセキュリティ要求にも対応。信頼される企業としての実績を作れます。',
  },
];

const BenefitsSection: React.FC = () => (
  <section id="benefits" className="py-24 bg-white">
    <div className="max-w-5xl mx-auto px-6">
      {/* Heading */}
      <div className="text-center mb-16">
        <span className="inline-block text-sky-600 text-sm font-bold tracking-widest uppercase mb-4">
          導入効果
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-800 leading-tight">
          UTM導入で<br className="md:hidden" />
          安心できる環境へ
        </h2>
        <p className="mt-4 text-slate-500 text-base max-w-xl mx-auto leading-relaxed">
          導入後すぐに効果を実感。社内のセキュリティ意識も自然と高まります。
        </p>
      </div>

      {/* Benefits grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
        {benefits.map((b) => (
          <div
            key={b.title}
            className="bg-slate-50 rounded-xl p-6 flex flex-col gap-4 border border-slate-100 hover:border-sky-200 transition-all duration-200 hover:-translate-y-1"
          >
            <div>
              <h3 className="font-bold text-slate-800 text-sm mb-1.5">{b.title}</h3>
              <p className="text-slate-500 text-xs leading-relaxed">{b.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Before/After */}
      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-red-50 border border-red-100 rounded-2xl p-7">
          <div className="flex items-center gap-2 mb-5">
            <span className="font-bold text-red-600 text-sm">導入前</span>
          </div>
          <ul className="space-y-3">
            {[
              'ウイルスソフトだけで不安な日々',
              'サイバー被害のリスクを常に抱える',
              '取引先からの信頼が得にくい',
              'ITトラブル対応に時間がかかる',
            ].map((t) => (
              <li key={t} className="text-slate-600 text-sm">
                {t}
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-sky-50 border border-sky-100 rounded-2xl p-7">
          <div className="flex items-center gap-2 mb-5">
            <span className="font-bold text-sky-600 text-sm">導入後</span>
          </div>
          <ul className="space-y-3">
            {[
              'ネットワーク全体を1台でまとめて守れる',
              '経営者が安心して本業に集中できる',
              '取引先・顧客からの信頼が向上',
              'IT運用の手間が大幅に削減できる',
            ].map((t) => (
              <li key={t} className="text-slate-600 text-sm">
                {t}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default BenefitsSection;
